/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require("./bootstrap");
// Import Bootstrap CSS directly (pre-compiled, fonts already handled)
import "bootstrap/dist/css/bootstrap.css";
// Import Font Awesome from CDN via HTML - avoid webpack font resolution
import "../../sass/app.scss";
// require('bootstrap-material-design')
/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require("./main");
